export const cgblue = "#004F8A"
export const cggreen = "#85BD3C"
